import { useEffect } from 'react';
import { AUTH_TOKEN } from 'constant';
import jwt from 'jwt-decode';
import { loggedInState, userTokenInfo, UserTokenType } from 'cache';
import LocalStore from 'helpers/localStore';

export default function UseGlobalSync() {
  useEffect(() => {
    const userCredentialHandler = (token?: string) => {
      try {
        const user = jwt(token || '') as UserTokenType;
        if (token && user) {
          loggedInState(true);
          userTokenInfo(user);
        } else {
          throw new Error();
        }
      } catch (err) {
        loggedInState(false);
        userTokenInfo({} as UserTokenType);
      }
    };
    LocalStore.subscribe(AUTH_TOKEN, userCredentialHandler);
    return () => {
      LocalStore.unsubscribe(AUTH_TOKEN, userCredentialHandler);
    };
  }, []);
}
